import { useState } from 'react'
import { IBankPaymentCode } from '../../../../common/interfaces/bankPaymentCode.interface'
import { CancelButton, CodeValue, EditButton } from './CodeActions'
import { SaveButton } from './SaveButton'

interface IProps {
  bank: IBankPaymentCode
  saving: boolean
  onSave: (bank: IBankPaymentCode, code: string) => Promise<boolean>
}

export const BankHabitatCode = ({ bank, saving, onSave }: IProps) => {
  const [editing, setEditing] = useState(false)
  const [code, setCode] = useState('')

  const trimmedCode = code.trim()
  const canSave = !!trimmedCode && trimmedCode !== (bank.habitat_bank_code ?? '')

  const startEditing = () => {
    setCode(bank.habitat_bank_code ?? '')
    setEditing(true)
  }

  const save = async () => {
    if (await onSave(bank, trimmedCode)) setEditing(false)
  }

  return (
    <div className='d-flex align-items-center flex-wrap gap-3'>
      <span className='text-muted fs-6'>Código Habitat del banco</span>
      {editing ? (
        <>
          <input
            className='form-control form-control-sm w-150px'
            aria-label={`Código Habitat de ${bank.description}`}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <CancelButton disabled={saving} onClick={() => setEditing(false)} />
          <SaveButton
            ariaLabel={`Guardar código Habitat de ${bank.description}`}
            disabled={!canSave}
            saving={saving}
            onClick={save}
          />
        </>
      ) : (
        <>
          <CodeValue value={bank.habitat_bank_code} />
          <EditButton
            ariaLabel={`Editar código Habitat de ${bank.description}`}
            onClick={startEditing}
          />
        </>
      )}
    </div>
  )
}
